export default [
  {
    path: "/policyList",
    name: "农技信息列表",
    component: () => import("../views/farmPolicy/policyList/index.vue"),
  },
];
